import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ projectMember }) => <>{projectMember?.member?.name}</>;

  return (
    <BulkActionModal
      title="Remove Team Members"
      variant="delete"
      confirmText="Remove"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .members()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will remove ${
        ids.length === 1 ? 'the selected team member' : `the ${ids.length} selected team members`
      } from the project. Members with logged time, expenses, or allocations will be skipped. This action cannot be undone.`}
    </BulkActionModal>
  );
}
